import React from 'react'

export default function Texts (props) {
  return (
    <div className='mtt-ttmzero-circle__circle-texts'>
      <p className='mtt-ttmzero-circle__circle-percent'><span className='countup-number'>{props.percent}</span>%</p>
      <p className='mtt-ttmzero-circle__circle-text'>{props.text}</p>
    </div>
  )
}
